module.exports = __webpack_public_path__ + "img/nu.90746345.png";